import styles from './Pagination.module.css';

type PaginationProps = {
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
  changePage: (pageNumber: number) => void;
  currentPage: number;
};

const Pagination = (props: PaginationProps) => {
  const pageNumbers = [];

  for (let i = 1; i <= props.totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className={styles.container}>
        <li
          className={`${styles.pageLink} ${props.currentPage === 1 && styles.inactive}`}
          onClick={
            props.currentPage > 1 ? () => props.changePage(props.currentPage - 1) : undefined
          }
        >
          {'‹'}
        </li>
        {pageNumbers.map(pageNumber => (
          <li key={pageNumber}>
            <div
              className={`${styles.pageLink} ${props.currentPage === pageNumber && styles.active}`}
              onClick={() => props.changePage(pageNumber)}
            >
              {pageNumber}
            </div>
          </li>
        ))}
        <li
          className={`${styles.pageLink} ${props.currentPage === 5 && styles.inactive}`}
          onClick={
            props.currentPage < props.totalPages
              ? () => props.changePage(props.currentPage + 1)
              : undefined
          }
        >
          {'›'}
        </li>
      </ul>
    </nav>
  );
};
export default Pagination;
